import { Geometry, FeatureCollection, Feature } from 'geojson';

export const createFeatureCollection = <G extends Geometry | null = Geometry>(
  features: Feature<G>[],
): FeatureCollection<G> => ({
  type: 'FeatureCollection',
  features,
});

export const createFeature = <G extends Geometry | null = Geometry>({
  geometry,
  id,
  properties,
}: Omit<Feature<G>, 'type'>): Feature<G> => ({
  type: 'Feature',
  geometry,
  id,
  properties,
});
